import React, { useState, useEffect } from 'react';
import { Container, Form, Col, Row, Modal } from 'react-bootstrap';
import moment from 'moment';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { TextInput, SelectInput, StyledRadioInput } from '../../../Helpers/Inputs';
import { InputMaskDate, NumberFormatDollars } from '../../../Helpers/Formatters';
import States from '../../../Helpers/Lists/States';
import NotesPagesNotification from '../../../../icons/NotesPagesNotification.svg';
import { IconButton, makeStyles, Tooltip, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import TitleComponent from '../../../Common/TitleComponent';
import BackNextButton from '../../../Common/BackNextButton';
import { customValidators, number as yupnumber } from '../../../Helpers/Validators/customValidators';
import { Purpose, SourceOfFunds } from '../../ABLTC/SubComponents/SelectOptions';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import '../../SharedComponents/BasicInfo/InsuredBasicInfo.scss'
import GetOwnerDetails from '../../Common/GetOwnerDetails';
import HandleNavigateToLicensingAndAppointmentLink from '../../../Helpers/HandleNavigateToLicensingAndAppointmentLink';
import Age from '../../../Helpers/Dates/Age';

const useStyles = makeStyles(theme => ({
    link: {
      color: `${theme.palette.primary.main} !important`,
      cursor: 'pointer'
    },
    insuranceTools: {
        fontSize: "0.75rem"
    }
  }))

export default function ApplicationInformation(props) {
    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: ApplicationInformation.ValidationSchema(),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const [show, setShow] = useState(false);
    const [disable, setdisable] = useState(false);
    const classes = useStyles();
    const formState = props.formState;
    const showErrorMessage = formState.applicationState && ((formState.solicitationState && (formState.solicitationState !== formState.applicationState)) || (formState.deliveryState && (formState.deliveryState !== formState.applicationState)))
    const availableProductUrl = process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST ? `${process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST}/inscapitasweb/ProductSearch.aspx` : 'https://ideas-qa07.msdwis.com/inscapitasweb/ProductSearch.aspx';
    const isLTC = props.fullFormState.pages.selectProduct && props.fullFormState.pages.selectProduct.category === 'LTC';

    const LightTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 11,
        },
    }))(Tooltip);

    const TooltipTitle = (text) => {
        return (
            <div className="p-0 light-tooltip">
                <LightTooltip title={
                    <div>
                        {text}
                    </div>
                } placement="top" enterTouchDelay={0} leaveTouchDelay={5}><InfoIcon color='disabled' /></LightTooltip>
            </div>
        )
    };

    const handleValueChange = (field, value) => {
        if (field === 'replacement') {
            setShow(true);
            let fullForm = { ...props.fullFormState };
            if (value === "yes") {
                fullForm.pages.applicationInformation.replacement = value;
                fullForm.pages.applicationInformation.purpose = "";
                fullForm.pages.applicationInformation.otherPurpose = "";
            }
            if (value === "no") {
                fullForm.pages.applicationInformation.replacement = value;
                fullForm.pages.applicationInformation.sourceOfFunds = "DirectBusiness";
                fullForm.pages.applicationInformation.exchangeLumpSum = "";
            }
            setValue(field, value);
            props.onMultiFieldChange(fullForm);
        } else {
            setValue(field, value);
            props.onFieldChange(field, value);
        }
        triggerValidation(field);
    };

    useEffect(() => {
        register({ name: 'applicationState' });
        setValue('applicationState', props.formState.applicationState || 'CA');

        register({ name: 'applicationDate' });
        setValue('applicationDate', props.formState.applicationDate);

        register({ name: 'solicitationDate' });
        setValue('solicitationDate', props.formState.solicitationDate);

        register({ name: 'solicitationState' });
        setValue('solicitationState', props.formState.solicitationState);

        register({ name: 'deliveryState' });
        setValue('deliveryState', props.formState.deliveryState);

        register({ name: 'replacement' });
        setValue('replacement', props.formState.replacement);

        register({ name: 'sourceOfFunds' });
        setValue('sourceOfFunds', props.formState.sourceOfFunds);

        register({ name: 'exchangeLumpSum' });
        setValue('exchangeLumpSum', props.formState.exchangeLumpSum);

        register({ name: 'purpose' });
        setValue('purpose', props.formState.purpose);

        register({ name: 'otherPurpose' });
        setValue('otherPurpose', props.formState.otherPurpose);

        register({name :'isTerm'});
        setValue('isTerm', props.isTerm);

    }, [register]);

    const calculateFYPAndRAP = (isFirstYearPremium) => {
        let firstYearPremium, recurringAnnualPremium, numPayments;
        const premiumMode = props.fullFormState.pages.selectProduct.premiumMode;
        const totalPremium = parseFloat(props.fullFormState.pages.selectProduct.premium === 'specificPremium' ? props.fullFormState.pages.selectProduct.specificPremium : props.fullFormState.pages.selectProduct.premium);
        
        switch (premiumMode) {
            case 'Single Pay':
                firstYearPremium = totalPremium;
                recurringAnnualPremium = 0;
                break;
            case '2 Pay':
            case '3 Pay':
            case '4 Pay':
            case '5 Pay':
            case '7 Pay':
            case '10 Pay':
            case '20 Pay':
                numPayments = parseInt(premiumMode.split(' ')[0]);
                firstYearPremium =  parseFloat((totalPremium / numPayments).toFixed(2));;
                recurringAnnualPremium = firstYearPremium;
                break;
            case 'Pay to 65':
            case 'Pay to 100':
                const targetAge = parseInt(premiumMode.split(' ')[2]);
                const currentAge = Age(props.fullFormState.pages.insuredBasicInfo.birthdate);
                numPayments = Math.abs(targetAge - currentAge);
                firstYearPremium = parseFloat((totalPremium / numPayments).toFixed(2));
                recurringAnnualPremium = firstYearPremium;
                break;
            default:
                firstYearPremium = totalPremium;
                recurringAnnualPremium = 0;
                break;
        }
        return isFirstYearPremium ? firstYearPremium : recurringAnnualPremium ;
    }
 

    useEffect(() => {
        window.scrollTo(0, 0);
        let fullForm = { ...props.fullFormState };
        const ownerDetails= GetOwnerDetails(fullForm);
        const applicationState = ownerDetails && ownerDetails !== null ? ownerDetails.state : '';
        fullForm.pages.applicationInformation.applicationState = applicationState;
        setValue('applicationState', applicationState);
        setdisable(true);

        // application date should be set based off US MT
        const usDate = new Date().toLocaleDateString('en-US', { timeZone: 'America/Boise' });
        const dateOfApplication = moment(new Date(usDate)).format('MM/DD/YYYY');
        fullForm.pages.applicationInformation.applicationDate = dateOfApplication;
        setValue('applicationDate', dateOfApplication);
        props.onMultiFieldChange(fullForm);
    }, [])

    const handleOnSubmit = () => {
        if (isLTC) {
            const fullForm = { ...props.fullFormState };
            fullForm.pages.applicationInformation.firstYearPremium = calculateFYPAndRAP(true);
            fullForm.pages.applicationInformation.recurringAnnualPremium = calculateFYPAndRAP(false);
            props.onMultiFieldChange(fullForm);
        }
        props.onNext();
    }

    return (
        <Container fluid className='border-class'>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                <Row className="justify-content-center pt-4">
                    <Col lg={4}>
                        <TitleComponent icon={NotesPagesNotification} title="Application Information" />
                        <Form.Group>
                            <SelectInput
                                name="applicationState"
                                id="applicationState"
                                label="Application State"
                                value={props.formState.applicationState}
                                onChange={e => handleValueChange('applicationState', e.target.value)}
                                errors={errors.applicationState}
                                inputRef={register}
                                selectOptions={States()}
                                hideEmptyOption
                                disabled={disable}
                            />
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="applicationDate"
                                id="applicationDate"
                                label="Application Date"
                                value={props.formState.applicationDate}
                                errors={errors && errors.applicationDate}
                                inputRef={register}
                                onChange={(e) => handleValueChange('applicationDate', e.target.value)}
                                InputProps={{
                                    inputComponent: InputMaskDate,
                                }}
                                disabled={disable}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Row>
                                <Col>
                                    <SelectInput
                                        name="solicitationState"
                                        id="solicitationState"
                                        label="Solicitation State "
                                        value={props.formState.solicitationState}
                                        errors={errors && errors.solicitationState}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('solicitationState', e.target.value)}
                                        selectOptions={States()}
                                        hideEmptyOption
                                    />
                                </Col>
                                <Col xs='1' className='pl-0 ml-0 mt-3'>{TooltipTitle('If communicating by phone the state that you are calling is to be indicated in the field below.')}</Col>
                            </Row>
                            {showErrorMessage &&
                                <React.Fragment>
                                    <div className="errorMessage softWarningMessage ml-0 mb-0">Solicitation and/or Delivery state does not equal the Application state. Please be aware that Application State, Solicitation State and Delivery State will be used for Licensing and Appointment check as well as Product availability when submitting this ticket.</div>
                                    <div className={classes.insuranceTools}>
                                        <div>For Product Availability <a className={classes.link} href={availableProductUrl} target='_blank' >click here.</a></div>
                                        <div>For Licensing and Appointment <a className={classes.link} onClick={() => HandleNavigateToLicensingAndAppointmentLink()}>click here.</a></div>
                                    </div>
                                </React.Fragment>
                            }                            
                        </Form.Group>

                        <Form.Group>
                            <TextInput
                                name="solicitationDate"
                                id="solicitationDate"
                                label="Solicitation Date"
                                value={props.formState.solicitationDate}
                                errors={errors && errors.solicitationDate}
                                inputRef={register}
                                onChange={(e) => handleValueChange('solicitationDate', e.target.value)}
                                InputProps={{
                                    inputComponent: InputMaskDate,
                                }}
                            />
                        </Form.Group>

                        <Form.Group>
                            <SelectInput
                                name="deliveryState"
                                id="deliveryState"
                                value={props.formState.deliveryState}
                                onChange={(e) => handleValueChange('deliveryState', e.target.value)}
                                label="Delivery State"
                                selectOptions={States()}
                                errors={errors.deliveryState}
                                inputRef={register}
                                hideEmptyOption
                            />
                        </Form.Group>

                        <Form.Group>
                            <StyledRadioInput
                                name="replacement"
                                id="replacement"
                                value={props.formState.replacement}
                                onChange={(e) => handleValueChange('replacement', e)}
                                options={[
                                    { value: 'yes', label: 'Yes' },
                                    { value: 'no', label: 'No' },
                                ]}
                                label={<div className='d-flex font-weight-bold'>Replacement<span className='mt-n1 ml-3'>{TooltipTitle('A replacement is any transaction in which a new life insurance policy or annuity contract is to be purchased by any means in which an existing individual or group life insurance policy or annuity contract has been or will be: surrendered, lapsed, partially surrendered, forfeited or otherwise terminated.')}</span></div>}
                                errors={errors.replacement}
                                inputRef={register}
                            />
                        </Form.Group>

                        {props.formState.replacement === "no" &&
                            <React.Fragment>
                                <Form.Group>
                                    <SelectInput
                                        name="purpose"
                                        id="purpose"
                                        value={props.formState.purpose}
                                        onChange={(e) => handleValueChange('purpose', e.target.value)}
                                        label="Purpose"
                                        selectOptions={Purpose()}
                                        errors={errors.purpose}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                {props.formState.purpose === "Other" &&
                                    <Form.Group>
                                        <TextInput
                                            name="otherPurpose"
                                            id="otherPurpose"
                                            label="Other Purpose Description"
                                            value={props.formState.otherPurpose}
                                            errors={errors && errors.otherPurpose}
                                            inputRef={register}
                                            onChange={(e) => handleValueChange('otherPurpose', e.target.value)}
                                        />
                                    </Form.Group>
                                }
                            </React.Fragment>
                        }

                        {props.formState.replacement !== "" &&
                                 <Form.Group>
                                     <SelectInput
                                         name="sourceOfFunds"
                                         id="sourceOfFunds"
                                         value={props.formState.sourceOfFunds}
                                         onChange={(e) => handleValueChange('sourceOfFunds', e.target.value)}
                                         label="Source Of Funds"
                                         selectOptions={SourceOfFunds()}
                                         errors={errors.sourceOfFunds}
                                         inputRef={register}
                                         disabled= {props.formState.replacement === "no"}
                                     />
                                 </Form.Group>
                        }

                        {props.formState.replacement === "yes" &&
                                 <Form.Group>
                                     <TextInput
                                         name="exchangeLumpSum"
                                         id="exchangeLumpSum"
                                         label="1035 Exchange/Lump Sum"
                                         value={props.formState.exchangeLumpSum}
                                         errors={errors && errors.exchangeLumpSum}
                                         inputRef={register}
                                         onChange={(e) => handleValueChange('exchangeLumpSum', e.target.value)}
                                     />
                                 </Form.Group>
                        }

                        {isLTC ?
                            <React.Fragment>
                                <Form.Group>
                                    <TextInput
                                        name="firstYearPremium"
                                        id="firstYearPremium"
                                        label="First Year Premium"
                                        value={calculateFYPAndRAP(true)}
                                        errors={errors && errors.firstYearPremium}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('firstYearPremium', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                        disabled={true}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="recurringAnnualPremium"
                                        id="recurringAnnualPremium"
                                        label="Recurring Annual Premium"
                                        value={calculateFYPAndRAP(false)}
                                        errors={errors && errors.recurringAnnualPremium}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('recurringAnnualPremium', e.target.value)}
                                        InputProps={{
                                            inputComponent: NumberFormatDollars,
                                        }}
                                        disabled={true}
                                    />
                                </Form.Group>
                            </React.Fragment> : ""
                        }

                    </Col>
                </Row>
                <BackNextButton onBack={props.onBack} />
                <Modal show={show} onHide={() => setShow(false)} animation={false} centered>
                    <Modal.Header className='pb-1'>
                        <Modal.Title>Help</Modal.Title>
                        <IconButton className="close-button" aria-label="close" onClick={() => setShow(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Modal.Header>
                    <Modal.Body className="d-flex align-items-center justify-content-center p-3 flex-column">
                        <div>
                            <h2 className='mt-1 mb-3'>Replacement</h2>
                            <p>A replacement is any transaction in which a new life insurance policy or annuity contract is to be purchased by any means in which an existing individual or group life insurance policy or annuity contract has been or will be: surrendered, lapsed, partially surrendered, forfeited or otherwise terminated.</p>
                        </div>
                    </Modal.Body>
                </Modal>
            </form>
        </Container>
    )
}

ApplicationInformation.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

ApplicationInformation.ValidationSchema = () => {
    return object().shape({
    applicationState: string().notRequired(), //.required("Application State is required."),
    applicationDate: string().typeError('Invalid date.').required('Application Date is required.'),
    solicitationState: string().required('Solicitation State is required.'),
    solicitationDate: customValidators.string().isFutureDate(),
    deliveryState: string().required('Delivery State is required.'),
    replacement: string().required('Replacement is required.'),
    sourceOfFunds: string().when('replacement', {
        is: (replacement) => replacement !== '',
        then: string().required('Source Of Funds is required.'),
        otherwise: string().notRequired()
      }),
    exchangeLumpSum: yupnumber().when(['replacement'], {
        is: (replacement) => replacement === 'yes',
        then: yupnumber().typeError('Must be a number')
            .transform(emptyStringToUndefined).required('Exchange / Lump Sum is required.'),
        otherwise: yupnumber().transform(emptyStringToUndefined).notRequired()
    }),
    purpose: string().when('replacement', {
        is: (replacement) => replacement === 'no',
        then: string().required('Purpose is required.'),
        otherwise: string().notRequired()
    }),
    otherPurpose: string().when('purpose', {
        is: (purpose) => purpose === 'Other',
        then: string().required('Other Purpose Description is required.').matches(/^[^\s]+(\s+[^\s]+)*$/, 'Invalid data. Remove extra spaces.').max(100, 'Maximum 100 characters are allowed.'),
        otherwise: string().notRequired()
    }),
    });
};

ApplicationInformation.DefaultFormState = (prefill = false) => {
    return {
        applicationState: prefill ? '' : 'CA', // remove once owner details are saved
        applicationDate: prefill ? '' : '',
        solicitationState: prefill ? '' : '',
        solicitationDate: prefill ? '' : '',
        deliveryState: prefill ? '' : '',
        replacement: prefill ? '' : '',
        sourceOfFunds: prefill ? '' : '',
        exchangeLumpSum: prefill ? 0 : 0,
        purpose: prefill ? '' : '',
        otherPurpose: prefill ? '' : '',
        firstYearPremium: '',
        recurringAnnualPremium: ''
    };
};



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ApplicationInformation/ApplicationInformation.js